import BaseServiceCrud from './BaseServiceCrud';

export default class UserChallengeService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user-challenge';
    }

    getByChallengeList(challengeId) {
        return this.fetch(`${this.domain}/${this.path}/by-challenge/${challengeId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
